const getSelectOptionsFromRegions = (regions: string[]) =>
  regions.map((option) => ({ value: option, label: option }));

export default getSelectOptionsFromRegions;
